import React from 'react'
import { FilterLabels, SearchFilter, VectorSearchFilters, FilterGroup } from '../../../../../lib/types'
import { Box, ComboboxItem, Group, OptionsFilter, Pill, Popover, Select, Text, rem } from '@mantine/core'
import { IconSearch } from '@tabler/icons-react'

type TypeAheadFilter = {
  term: keyof typeof FilterLabels
  selectedFilters: VectorSearchFilters
  searchFilters: SearchFilter | undefined
  onAdd: (term: string, value: string) => void
  onRemove: (term: string, value: string) => void
}

export const TypeAheadFilter = ({ term, selectedFilters, searchFilters, onRemove, onAdd }: TypeAheadFilter) => {
  const handleChange = (value: string | null) => {
    if (value) onAdd(term, value)
  }

  const optionsFilter: OptionsFilter = ({ options, search }) => {
    const termFilters = selectedFilters[term] ?? []
    return (options as ComboboxItem[])?.filter(option => !termFilters.includes(option.value) && option.value.toLowerCase().includes(search.toLowerCase()))
  }

  return (
    <Group>
      <Popover
        width={600}
        position="bottom"
        withArrow
        arrowSize={14}
        offset={0}
        trapFocus
      >
        <Popover.Target>
          <Text
            size='sm'
            mx={!!selectedFilters[term] && !!selectedFilters[term]?.length ? 0 : 30}
            style={{ cursor: 'pointer', textDecoration: 'underline', fontWeight: 600 }}
          >
            {FilterLabels[term]}:
          </Text>
        </Popover.Target>
        <Popover.Dropdown>
          <Box>
            <Select
              label={FilterLabels[term]}
              onChange={value => handleChange(value)}
              placeholder={`Search ${FilterLabels[term]}s`}
              data={searchFilters ? searchFilters[term as FilterGroup] : []}
              filter={optionsFilter}
              maxDropdownHeight={500}
              leftSection={<IconSearch style={{ width: rem(18), height: rem(18) }} />}
              searchable
            />
          </Box>
        </Popover.Dropdown>
      </Popover>
      {!!selectedFilters[term] && !!selectedFilters[term]?.length &&
      <>
        {(selectedFilters[term] as string[])?.map((filterValue, i) => (
          <Pill
            key={i}
            defaultChecked={true}
            size='xl'
            c='blue'
            withRemoveButton
            maw={300}
            style={{ textOverflow: 'ellipsis' }}
            onRemove={() => onRemove(term, filterValue)}
          >
            {term === 'surveyCodeSurveyShortName' ? filterValue.split(' - ').slice(0, -1).join(' - ') : filterValue}
          </Pill>
        ))}
      </>}
    </Group>
  )
}
